interface ParseMultiValueParamOptions {
  itemPattern?: RegExp;
}

export const parseMultiValueParam = (
  value: string | null,
  options: ParseMultiValueParamOptions = {},
): string[] =>
  value
    ?.split(',')
    .map(item => item.trim())
    .filter(item => item && (!options.itemPattern || options.itemPattern.test(item))) ?? [];

const ID_PARAM_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;

export const parseIdListParam = (value: string | null): string[] =>
  parseMultiValueParam(value, { itemPattern: ID_PARAM_PATTERN });

export const serializeMultiValueParam = (value: string[] = []): string | undefined => {
  const normalized = [...new Set(value.filter(Boolean))].sort();
  return normalized.length > 0 ? normalized.join(',') : undefined;
};
